export class AddressProviderMapper {
    public static mapValidatePOSTResponse(data: APIv3.ValidateAddressResult): OLO.DTO.ValidateAddressResult {
        return data
            ? {
                  FormattedAddress: data.FormattedAddress,
                  StructuredAddressDto: data.StructuredAddressDto
                      ? {
                            Street: data.StructuredAddressDto.Street,
                            BuildingNumber: data.StructuredAddressDto.BuildingNumber,
                            Unit: data.StructuredAddressDto.Unit,
                            City: data.StructuredAddressDto.City,
                            Postcode: data.StructuredAddressDto.Postcode,
                            Country: data.StructuredAddressDto.Country,
                            State: data.StructuredAddressDto.State,
                            Geolocation: data.StructuredAddressDto.Geolocation
                                ? {
                                      Latitude: data.StructuredAddressDto.Geolocation.Latitude,
                                      Longitude: data.StructuredAddressDto.Geolocation.Longitude,
                                  }
                                : null,
                        }
                      : null,
              }
            : null;
    }

    public static mapAddressSugesstionsPOSTResponse(data: APIv3.AddressSugestionsDto): OLO.DTO.AddressSugestionsDto {
        return data
            ? {
                  AddressSugestions: data.AddressSugestions,
              }
            : null;
    }
}
